export const JIRA_PROJECTS_MODEL = {
  KEY: 'key',
  NAME: 'name',
  LAST_ACTIVITY: 'last_activity',
  ASSIGNEES: 'assignees',
  EPICS: 'associated_count',
  EPICS_DEPRECATED: 'epics',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  ISSUES_WITH_NO_EPICS: 'issues_with_no_epics',
  URL: 'url'
};

export const JIRA_INITIATIVES_MODEL = {
  KEY: 'key',
  NAME: 'name',
  ASSIGNEES: 'assignees',
  EPICS: 'associated_count',
  EPICS_DEPRECATED: 'epics',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  ISSUES_WITH_NO_EPICS: 'issues_with_no_epics',
  URL: 'url',
  STATUS: 'status'
};

export const JIRA_LABELS_MODEL = {
  KEY: 'key',
  NAME: 'name',
  URL: 'url',
  ASSIGNEES: 'assignees',
  JIRA_ISSUES: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte'
};

export const JIRA_EPICS_MODEL = {
  KEY: 'key',
  NAME: 'name',
  ASSIGNEES: 'assignees',
  JIRA_ISSUES: 'associated_count',
  JIRA_ISSUES_DEPRECATED: 'issues_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  STATUS: 'status',
  URL: 'url'
};

export const JIRA_CUSTOM_FIELD_MODEL = {
  KEY: 'key',
  NAME: 'name',
  URL: 'url',
  ASSIGNEES: 'assignees',
  JIRA_ISSUES: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte'
};

export const TABLE_MODEL_JIRA_PROJECTS = {
  KEY_CELL: 'key_cell',
  NAME_CELL: 'name_cell',
  LAST_ACTIVITY_CELL: 'last_activity_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  EPICS_CELL: 'epics_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  ISSUES_WITH_NO_EPICS_CELL: 'issues_with_no_epics_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_JIRA_INITIATIVES = {
  KEY_CELL: 'key_cell',
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  EPICS_CELL: 'epics_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_JIRA_EPICS = {
  KEY_CELL: 'key_cell',
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  JIRA_ISSUES_CELL: 'jira_issues_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_JIRA_LABELS = {
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  JIRA_ISSUES_CELL: 'jira_issues_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_JIRA_CUSTOM_FIELD = {
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  JIRA_ISSUES_CELL: 'jira_issues_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const DYNAMIC_ISSUE_TYPES_MODEL = {
  KEY: 'key',
  NAME: 'name',
  ASSIGNEES: 'assignees',
  PARENT: 'parent',
  CHILDREN_COUNT: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  STATUS: 'status',
  URL: 'url'
};

export const TABLE_MODEL_DYNAMIC_ISSUE_TYPES = {
  KEY_CELL: 'key_cell',
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  PARENT_CELL: 'parent_cell',
  CHILDREN_COUNT_CELL: 'children_count_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};
